module.exports = __webpack_public_path__ + "media/images/flags/IQ-42384607fbcdfe6e184190c48a2875c3.svg";